import styled from 'styled-components';
import {
  lighten,
} from 'polished';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Onboarding = styled(Flex).attrs({
  column: true,
  spacing: 30,
  padding: '30px 20px',
})`
  font-family: avenir;
  border: 1px solid ${props => props.theme.colors.primary};
`;

export const ProgressBar = styled.div`
  width: 100%;
  border-radius: 20px;
  background: rgb(238, 238, 238);
  overflow: hidden;
`;

export const Progress = styled.div`
  width: 0%;
  height: 20px;
  border-radius: 20px;
  transition: width 0.5s;
  background-color: ${props => props.theme.colors.primary};
`;

export const Article = styled.a`
  color: ${props => props.theme.colors.link};
  font-family: avenir;
  font-weight: normal;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const GoalButton = styled(Button).attrs({
  appearance: 'primary',
})`
  color: #ffffff;
  font-size: 20px;
  font-weight: 400;
  font-family: avenir;
  padding: 13px 32px;
  border-radius: 50px;
  box-shadow: 1px 1px 8px #888;
  background-color: ${props => props.theme.colors.goalButton};

  &:hover {
    background-color: ${props => lighten(0.10, props.theme.colors.goalButton)};
  }
`;

export const Hr = styled.hr`
  margin: auto;
  width: 25%;
  border-top: 1px solid #757575;
`;
